module.exports = __webpack_public_path__ + "img/ic-move-black.b0ec5d91.svg";